import { RefObject, useCallback, useEffect, useState } from 'react';

const gapAboveWindowBottom = 18;
const maximumMenuHeight = 512;
const minimumMenuHeight = 160;

export const useMenuHeight = (pillRef: RefObject<HTMLElement>, open: boolean) => {
  const [maxHeight, setMaxHeight] = useState(maximumMenuHeight);

  const measure = useCallback(() => {
    if (!pillRef.current) return;

    const spaceBelowPill = window.innerHeight
      - pillRef.current.getBoundingClientRect().bottom
      - gapAboveWindowBottom;

    setMaxHeight(Math.min(maximumMenuHeight, Math.max(minimumMenuHeight, spaceBelowPill)));
  }, [pillRef]);

  useEffect(() => {
    if (!open) return;

    window.addEventListener('resize', measure);
    window.addEventListener('scroll', measure, true);

    return () => {
      window.removeEventListener('resize', measure);
      window.removeEventListener('scroll', measure, true);
    };
  }, [open, measure]);

  return { maxHeight, measure };
};
